import { DISTROLISTDATA, DISTRODATA, FETCH, FETCH2 } from './actionType'
import axios from 'axios'
import tapConfig from '../../tapConfig'

export function distroListData(data) {
  return {
    type: DISTROLISTDATA,
    data: data,
  }
}
export function distroData(data) {
  return {
    type: DISTRODATA,
    data: data,
  }
}

export function listDistroListData(blossomID) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching(true))
        axios
          .get(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/distro_lists?key=' +
              encodeURIComponent(apiKey) +
              '&group_id=' +
              encodeURIComponent(blossomID),
          )
          .then(function (response) {
            if (response.data === null) {
              response.data = ''
            }
            dispatch(distroListResponseData(response))
            dispatch(apiFetching(false))
          })
          .catch(function () {
            // removed error from function
            dispatch(apiFetching(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching(false))
      })
  }
}

export function addDistroListEntry(blossomID, entry) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config?.target_outreach_manager?.apiKey
        const baseUrl = config?.target_outreach_manager?.url
        if (!baseUrl) {
          dispatch(apiFetching2(false))
          return
        }
        const url =
          baseUrl +
          'target_emergency_alerts/v1/distro_lists?key=' +
          encodeURIComponent(apiKey)
        const requestBody = {
          group_id: blossomID,
          address: entry,
        }
        dispatch(apiFetching2(true))
        axios
          .post(url, requestBody)
          .then(function (response) {
            // Added below to  get a pop up window when successful
            if (response.status === 201) {
              window.alert(
                'Distribution List Entry Successfully Added. \n\nYou will need to wait up to 24 hours to use new distribution list.',
              )
            } else {
              window.alert('Distribution List Entry Not Successfully Added')
            }
            dispatch(listDistroListData(blossomID))
            dispatch(apiFetching2(false))
          })
          .catch(function (error) {
            console.error('[addDistroListEntry] API error:', error)
            dispatch(apiFetching2(false))
          })
      })
      .catch((error) => {
        console.error('[addDistroListEntry] outer catch error:', error)
        console.error('[addDistroListEntry] error stack:', error?.stack)
        dispatch(apiFetching2(false))
      })
  }
}

export function removeDistroListEntry(blossomID, entry) {
  return function (dispatch) {
    tapConfig()
      .then((config) => {
        const apiKey = config.target_outreach_manager.apiKey
        dispatch(apiFetching2(true))
        axios
          .delete(
            config.target_outreach_manager.url +
              'target_emergency_alerts/v1/distro_lists?key=' +
              encodeURIComponent(apiKey) +
              '&group_id=' +
              encodeURIComponent(blossomID) +
              '&address=' +
              encodeURIComponent(entry),
          )
          .then(function (response) {
            // Added below to  get a pop up window when successful
            if (response.status === 204) {
              window.alert('Distribution List Entry Successfully Deleted')
            } else {
              window.alert('Distribution List Entry Not Successfully Deleted')
            }
            dispatch(listDistroListData(blossomID))
            dispatch(apiFetching2(false))
          })
          .catch(function () {
            // removed error from function
            dispatch(apiFetching2(false))
          })
      })
      .catch((error) => {
        console.error('Error fetching tapConfig:', error)
        dispatch(apiFetching2(false))
      })
  }
}

function distroListResponseData(response) {
  return {
    type: DISTROLISTDATA,
    data: response.data,
  }
}

function apiFetching(status) {
  return {
    type: FETCH,
    fetching: status,
  }
}

function apiFetching2(status) {
  return {
    type: FETCH2,
    fetching: status,
  }
}
